import { Controller } from "@hotwired/stimulus";

// Full-screen photo lightbox for the listing gallery (SUR-2302). No Figma spec
// exists for the expanded view, so this is designed to the dark editorial
// system: near-black backdrop, contained image, Playfair counter, gold hover
// accents, ‹ › + keyboard navigation.
//
// The photo list comes from the DOM: every [data-connect-gallery-target=item]
// link inside the controller scope, in order — the 9 visible tiles plus hidden
// links for the rest of the MLS photos. With JS off the tiles remain plain
// links to the full-size images (progressive enhancement).
export default class extends Controller {
  static targets = ["item", "modal", "image", "counter", "caption"];

  connect() {
    this.index = 0;
    this.boundKeydown = (e) => {
      if (this.modalTarget.hidden) return;
      if (e.key === "Escape") this.close();
      if (e.key === "ArrowRight") this.next();
      if (e.key === "ArrowLeft") this.prev();
    };
    document.addEventListener("keydown", this.boundKeydown);
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundKeydown);
    document.body.style.overflow = "";
  }

  open(event) {
    event.preventDefault();
    this.index = this.itemTargets.indexOf(event.currentTarget);
    if (this.index < 0) this.index = 0;
    this.modalTarget.hidden = false;
    document.body.style.overflow = "hidden"; // freeze page scroll behind the lightbox
    this.render();
  }

  close() {
    this.modalTarget.hidden = true;
    document.body.style.overflow = "";
  }

  // Close on backdrop click — but not on the image/controls.
  backdrop(event) {
    if (event.target === this.modalTarget) this.close();
  }

  next() {
    this.index = (this.index + 1) % this.itemTargets.length;
    this.render();
  }

  prev() {
    this.index = (this.index - 1 + this.itemTargets.length) % this.itemTargets.length;
    this.render();
  }

  render() {
    const item = this.itemTargets[this.index];
    if (!item) return;
    this.imageTarget.src = item.href;
    this.imageTarget.alt = item.dataset.galleryAlt || "";
    if (this.hasCounterTarget) this.counterTarget.textContent = `${this.index + 1} / ${this.itemTargets.length}`;
    if (this.hasCaptionTarget) this.captionTarget.textContent = item.dataset.galleryAlt || "";
    // Warm the neighbors so arrowing feels instant.
    [this.index + 1, this.index - 1].forEach((i) => {
      const neighbor = this.itemTargets[(i + this.itemTargets.length) % this.itemTargets.length];
      if (neighbor) new Image().src = neighbor.href;
    });
  }
}
